import config from "./config";
import api from './api'
import { language } from '../stores/storages/LanguageStorage';
import OsUtils from "../lib/os";
import StringUtils from "../lib/string";

const CHECK_AUTH = {
   CLIENT_TYPE: 'desktop',
   REVISION: 10103,
   VERSION: '1.1',
   LANGUAGE: 'vi',
   COUNTRY: 'VN'
}

export const AuthServices = async (ssid) => {
   const device = OsUtils.getDeviceName()

   const data = {
      params: {
         ssid,
         clientType: CHECK_AUTH.CLIENT_TYPE,
         revision: CHECK_AUTH.REVISION,
         version: CHECK_AUTH.VERSION,
         language: CHECK_AUTH.LANGUAGE,
         country: CHECK_AUTH.COUNTRY,
         device: device,
         deviceId: '',
      }
   }
   const options = {
      customKey: ssid,
   }
   const res = await api.request({
      method: config.endpoints.auth.checkAuth.method,
      path: config.endpoints.auth.checkAuth.path,
      host: config.host,
      data,
      options,
   })

   return res;
}

export const AuthSsoServices = async (code, ssid) => {
   const formData = new FormData()
   formData.append('code', code)
   formData.append('language', language.language)
   formData.append('ssid', ssid)

   const options = {
      headers: {
         'Content-Type': 'multipart/form-data',
      },
      customKey: code,
      decrypt: true,
   }

   const res = await api.request({
      method: config.endpoints.auth.checkAuthSso.method,
      path: config.endpoints.auth.checkAuthSso.path,
      host: config.host,
      data: formData,
      options,
   })

   return res;
}